import { Modal } from "antd";
import React, { useState, useRef, useEffect } from "react";
import { closeMergeRequestBrandProcessLog, getSelectedMergedBrandProcessLogDetails, openMergeRequestBrandProcessLog } from "../../../redux/LivePlatform/LivePlatformAction";
import MergeRequestBrandProcessLogModal from "./MergeRequestBrandProcessLogModal";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";
import { useAppDispatch } from "../../../redux/useAppDispatch";



interface OpenProcessLogDetailsProps {
  data: any;
  record: any;
  index: any;
}

const OpenMergeRequestProcessLogModal = (props: OpenProcessLogDetailsProps) => {
  const openMergedDuplicateBrandProcessLogModalState = useSelector(
    (state: RootState) =>
      state.livePlatformState.duplicateBrandState.mergedDuplicateBrandProcessLogDetails.openMergedDuplicateBrandProcessLogModalState
  );

  const dispatch = useAppDispatch();

  const [showFullText, setShowFullText] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef<HTMLSpanElement>(null);

  const { data } = props;
  const fullData = data.split("|||");
  const firstPart = fullData[0];

  // Check if the text is overflowing
  useEffect(() => {
    if (textRef.current) {
      setIsOverflowing(
        textRef.current.scrollWidth > textRef.current.clientWidth
      );
    }
  }, []);

  // Handle clicking "More"
  const handleMoreClick = () => {
    if (fullData.length > 1) {
      dispatch(openMergeRequestBrandProcessLog());
      dispatch(getSelectedMergedBrandProcessLogDetails(props.index ));
    } else {
      setShowFullText(true);
    }
  };

  return (
    <>
      <span
        ref={textRef}
        style={{
          whiteSpace: showFullText ? "normal" : "nowrap",
          overflow: showFullText ? "visible" : "hidden",
          textOverflow: showFullText ? "clip" : "ellipsis",
          maxWidth: "1000px",
          display: "inline-block",
        }}
      >
        {showFullText ? data : firstPart}
      </span>
      {(fullData.length > 1 || isOverflowing) && !showFullText && (
        <div className="link" onClick={handleMoreClick}>
          More
        </div>
      )}
      <MergeRequestBrandProcessLogModal
      
        openState={openMergedDuplicateBrandProcessLogModalState}
        open={() => dispatch(openMergeRequestBrandProcessLog())}
        close={() => dispatch(closeMergeRequestBrandProcessLog())}
      />
    </>
  );
};

export default OpenMergeRequestProcessLogModal;
